import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '@/pages/sm/index'
import Demo from '@/components/dropDown'
import Main from '@/pages/sm/index2'
import Bbs from '@/pages/sm/bbs'
import Findex from '@/pages/pc/index'
import StudyAbroad from '@/pages/sm/studyAbroad'
import StudyAbroadPc from '@/pages/pc/studyAbroadPc'
import LandingPage from '@/pages/sm/landingPage'
import LandingPagePsychology from '@/pages/sm/landingPagePsychology'
import LandingPagePsychologyA from '@/pages/sm/landingPagePsychologyA'
Vue.use(Router)

const router = new Router({
	mode: 'history',
  routes: [
    {
      path: '/index',
      name: 'Bbs',
      component: Bbs,
      meta: {
        title: '免联考国际硕士和博士'
      }
    },
    {
      path: '/landingPage',
      name: 'LandingPage',
      component: LandingPage,
      meta: {
          title:"布雷斯特高等商学院"
      }
    },
    {
      path: '/landingPagePsychology',
      name: 'LandingPagePsychology',
      component: LandingPagePsychology,
      meta: {
          title:"布雷斯特高等商学院"
      }
    },
    {
      path: '/landingPagePsychologyA',
      name: 'LandingPagePsychologyA',
      component: LandingPagePsychologyA,
      meta: {
          title:"布雷斯特高等商学院"
      }
    },
    {
      path: '/studyAbroad',
      name: 'StudyAbroad',
      component: StudyAbroad,
      meta: {
        title: '海纳易学国际教育'
      }
    },
    {
      path: '/studyAbroadPc',
      name: 'StudyAbroadPc',
      component: StudyAbroadPc,
      meta: {
        title: '海纳易学国际教育'
      }
    },
    
    {
      path: '/indexOld',
      name: 'index',
      component: Index,
    },
    {
      path: '/demo',
      name: 'Demo',
      component: Demo
    },
    {
      path: '/index2',
      name: 'Main',
      component: Main
    },
    {
      path: '/pc/index',
      name: 'Findex',
      component:Findex
    },
    
  ],
  srcollBehavior(to,from,savedPosition){
    if(to.hash){
		  return {
		     selector:to.hash
		    }
        }
    }
})

//router.beforeEach((to, from, next) => { 
//	if(JSON.stringify(to.query) != '{}') {
//		if(to.query.v == "a") { 
//			next({ path: '/index', replace: true }); 
//		} else {  
//			next({ path: '/main', replace: true })
//		} 
//	} else { 
//		next(); 
//	}
//});

export default router;





// WEBPACK FOOTER //
// ./src/router/index.js